import * as z from "zod";

export const updateReturnWithWaivedDraftFee = {
  name: "updateReturnWithWaivedDraftFee" as const,
  input: z.object({ id: z.string(), waivedDraftFee: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
